import React from "react";

import clsx from "clsx";

import { type TableTreeColumn } from "@devexpress/dx-react-grid-bootstrap4";
import { useMaxIndentLevel } from "@features/sales-v3/table/contexts";

export const TableTreeColumnIndent = ({
  level,
  isCompacted,
}: TableTreeColumn.IndentProps & { isCompacted: boolean }) => {
  const maxIndentLevel = useMaxIndentLevel();

  return (
    <>
      {Array(level)
        .fill(null)
        .map((_, index) => (
          <div
            key={index}
            className={clsx("shrink-0", {
              "w-[34px]": !isCompacted,
              "w-[20px]": isCompacted,
            })}
          />
        ))}
      {maxIndentLevel > 0 && level === maxIndentLevel && (
        <div
          className={clsx("shrink-0 flex items-center justify-end", {
            "w-[34px] pr-4": !isCompacted,
            "w-[24px] pr-2": isCompacted,
          })}
        >
          <i
            className={clsx(
              "fa-regular fa-sharp fa-arrow-turn-down-right",
              "text-gray-1 group-hover/row:text-cosmic+1",
            )}
          />
        </div>
      )}
    </>
  );
};
